import React from 'react';
import './App.css';
import BoggleGame from './components/BoggleGame';

const App: React.FC = () => {
  return <BoggleGame />;
}

export default App;